
import React from 'react';

const KeyTakeaway: React.FC = () => {
  return (
    <div className="space-y-1">
      <h4 className="font-medium text-hormony-charcoal">
        Key Takeaway:
      </h4>
      <p className="text-hormony-charcoal/80 italic">
        What you eat affects how your body responds to stress. Eating balanced, nutrient-dense meals helps keep cortisol in check.
      </p>
    </div>
  );
};

export default KeyTakeaway;
